module.exports = __webpack_public_path__ + "static/img/ministry-of-justice-foreigners.2ca61ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/ministry-of-justice-foreigners.jpg
// module id = deCs
// module chunks = 0